import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ListMetadata } from "app/models/list-metadata.model";
import { HttpClientService } from "app/services/httpClient/httpclient.service";

import { Observable } from "rxjs";
import { AllPendingSchedulePageResponse, DirectNotificationRequest, MessageInstanceActionStatusDto, ScheduleContextUpdateRequest, ScheduleNotificationRequest, ScheduleResponse, ScheduleStatusResponse, UpdateScheduleStateRequest } from "../model/notification-model";
@Injectable()
export class NotificationService {

  private baseUrl = '/k7o/gui-shim/kss-airship';                                                        

  constructor(private http: HttpClientService) {}

  // --- /list ---
  list(offset = null, limit = null, search?: Array<{ key: string, value: string }>,
       globalSearch?: string, sort?: string, sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(`${this.baseUrl}/list?${params.toString()}`);
  }

  // --- /status-transitions ---
  getActionStatus(): Observable<{ data: MessageInstanceActionStatusDto[], metadata: ListMetadata }> {
    return this.http.getPaged(`${this.baseUrl}/status-transitions`);
  }

  // --- /prepare-scheduled ---
  createPrepareScheduled(request: ScheduleNotificationRequest): Observable<void> {
    return this.http.post(`${this.baseUrl}/prepare-scheduled`, request);
  }

  updatePrepareScheduled(request: ScheduleNotificationRequest): Observable<void> {
    return this.http.put(`${this.baseUrl}/prepare-scheduled`, request);                                                                           
  }

  deletePrepareScheduled(headId?: number, challengeId?: number): Observable<void> {
    const params = new URLSearchParams();
    if (headId != null)      params.set('headId', String(headId));      // ✅ fix nome parametro
    if (challengeId != null) params.set('challengeId', String(challengeId));
    return this.http.delete(`${this.baseUrl}/prepare-scheduled?${params.toString()}`);
  }

  // --- /notify-scheduled ---
  getNotificationDetail(challengeId: number): Observable<ScheduleResponse> {  // ✅ tipo corretto, un solo metodo
    return this.http.get(`${this.baseUrl}/notify-scheduled?challengeId=${challengeId}`);
  }

  notifyScheduled(request: ScheduleNotificationRequest): Observable<void> {
    return this.http.post(`${this.baseUrl}/notify-scheduled`, request);
  }

  updateScheduleState(request: UpdateScheduleStateRequest): Observable<void> {
    return this.http.put(`${this.baseUrl}/notify-scheduled`, request);
  }

  // --- /direct-notify ---
  sendDirectNotification(request: DirectNotificationRequest): Observable<void> {
    return this.http.post(`${this.baseUrl}/direct-notify`, request);  // ✅ fix URL
  }

  // --- /updates/sse ---
  streamStatusUpdates(request: ScheduleContextUpdateRequest): Observable<any> {
    return this.http.post(`${this.baseUrl}/updates/sse`, request);
  }

  // --- /trigger-start-schedule ---
  triggerStartSchedule(): Observable<void> {
    return this.http.put(`${this.baseUrl}/trigger-start-schedule`, null);
  }
}


// WEBPACK FOOTER //
// ./src/app/views/notification/services/notification-service.service.ts